import { HTTP_CODE } from "../service/axios_constants";
import { checkNull, getLocal } from "../filters/filters";
import { isArray } from "util";
export default {
  created() {
    this.loadCreateDatePtr();
  },
  data() {
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      selectByCompany: [], //下发公司select
      resCompanyListInfo: [], //商户列表
      mixin_parmesSelectDistributeChannel: [], //商户名称下拉select
      parmesSelectDistributeChannel: "", //下发通道select
      mixin_parmesCooperatorIdList: [],
      mod_cooperatorIdList: "",
      totalCount: 0, //总数
      totalPageCount: 0
    };
  },
  methods: {
    xhrQueryCreateHandler() {
      console.log("我是mixin里的查询");
    },

    //下发公司下拉列表
    xhrSelectCompany() {
      this.$http.postSelectByCompanyName().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.selectByCompany = res.data;
        }
      });
    },

    // xhr -- 商户列表
    xhrCompanyList() {
      this.$http.postSelectCooperatorIdList().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resCompanyListInfo = res.data;
        }
      });
    },

    //商户名称下拉列表
    mixin_xhrSelectAisle(callback) {
      //请求商户名称LIST
      this.$http
        .postSelectCooperatorIdList()
        .then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.mixin_parmesSelectDistributeChannel = res.data;
            if (this.mixin_parmesCooperatorIdList.length === 0) {
              //如果 商户编号集合为空 设置商户编号为所有商户Id集合
              this.mixin_parmesCooperatorIdList = this.mixin_parmesSelectDistributeChannel.map(
                (item, index) => {
                  return item.cooperatorId;
                }
              );
            }
            // else {
            //    //如果不为空 设置为所选(商户名称)商户ID
            //     this.mixin_parmesCooperatorIdList = [this.mod_cooperatorIdList];
            // }
          }
        })
        .then(() => {
          if (typeof callback === "function") {
            callback();
          }
        });
    },
    //下发通道下拉列表
    xhrSelectAisle() {
      this.$http.postSelectDistributeChannel().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.parmesSelectDistributeChannel = res.data;
        }
      });
    },
    /**
     * @param {Object} obj 需要清空的input model集合
     * */
    //清除按钮
    mixinEmptuButton(obj) {
      if (this.mod_cooperatorIdList) {
        this.mod_cooperatorIdList = "";
        this.mixin_parmesCooperatorIdList = this.mixin_parmesSelectDistributeChannel.map(
          (item, index) => {
            return item.cooperatorId;
          }
        );
      } else {
        this.mixin_parmesCooperatorIdList = this.mixin_parmesSelectDistributeChannel.map(
          (item, index) => {
            return item.cooperatorId;
          }
        );
      }

      if (this.mod_batchState) {
        this.mod_batchState = "";
      }
      this.mod_cooperatorIdList = "";
      for (var prop in obj) {
        if (Array.isArray(obj[prop])) {
          obj[prop] = [];
          continue;
        }
        if (prop !== "") {
          obj[prop] = "";
        }
      }
      this.loadCreateDatePtr();
      if (this.xhrQueryCreateBtnHandler) {
        this.xhrQueryCreateBtnHandler();
      }
    },
    loadCreateDatePtr() {
      if (this.mod_datePtr) {
        if (!this.mod_datePtr[0] && typeof this.mod_datePtr[0] !== "string") {
          var date = new Date();
          var thisMonth = new Date().getMonth();
          var day = new Date().getDate();
          var thisYear = new Date().getFullYear();
          this.mod_datePtr = [
            new Date(thisYear, thisMonth, 1),
            new Date(thisYear, thisMonth, day)
          ];
        } else if (
          this.mod_datePtr[0] &&
          typeof this.mod_datePtr[0] == "string"
        ) {
          var date = new Date();
          var thisMonth = new Date().getMonth();
          var day = new Date().getDate();
          var thisYear = new Date().getFullYear();
          this.mod_datePtr = [
            new Date(thisYear, thisMonth, 1),
            new Date(thisYear, thisMonth, day)
          ];
        }
      }
    }
  }
};

//任务管理 -- 任务类型
export const TaskTypeList = {
  data() {
    return {
      resTaskTypeList: [],
      isGongqingCity: ""
    };
  },

  created() {
    if (!checkNull(getLocal("userMessage"))) {
      this.isGongqingCity = JSON.parse(
        getLocal("userMessage")
      ).distributeCompanyType;
    }
    this.xhrTaskTypeList();
  },

  methods: {
    xhrTaskTypeList() {
      if (this.isGongqingCity == 0) {
        this.$http.getTaskTypeList().then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.resTaskTypeList = res.data;
          }
        });
      } else {
        this.$http.getJXTaskTypeList().then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.resTaskTypeList = res.data;
          }
        });
      }
    }
  }
};

// 商户列表
export const getCooperatorsList = {
  data() {
    return {
      resCooperatorsList: []
    };
  },

  created() {
    this.xhrGetCooperatorsList();
  },

  methods: {
    xhrGetCooperatorsList() {
      this.$http.postSelectCooperatorIdList().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resCooperatorsList = res.data;
        }
      });
    }
  }
};

// 单+多批+新网 - 关联任务
export const getAssociatedTaskList = {
  data() {
    return {
      resTaskList: []
    };
  },

  created() {},

  methods: {
    xhrGetAssociatedTask() {
      this.$http.getAssociatedTask().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resTaskList = res.data;
        }
      });
    }
  }
};

//用工结算单慧用工+网商公管户 - 职位列表
export const PostPositionList = {
  data() {
    return {
      resPositionList: []
    };
  },

  created() {
    this.xhrPositionList();
  },

  methods: {
    xhrPositionList() {
      this.$http.postPositionList().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resPositionList = res.data;
        }
      });
    }
  }
};

// xhr -- 下发公司
export const getDistributeCompanyList = {
  data() {
    return {
      resDistributeCompanyList: []
    };
  },

  created() {
    this.xhrDistributeCompanyList();
  },

  methods: {
    xhrDistributeCompanyList() {
      this.$http.postSelectByCompanyName({}).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resDistributeCompanyList = res.data;
        }
      });
    }
  }
};

// xhr -- 查询商户字段
export const getFindCooperatorConfField = {
  data() {
    return {
      resFindCooperatorConfField: []
    };
  },

  created() {
    this.xhrFindCooperatorConfField();
  },

  methods: {
    xhrFindCooperatorConfField() {
      this.$http.getFindCooperatorConfField({}).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resFindCooperatorConfField = res.data;
        }
      });
    }
  }
};

// xhr -- 查询全部开启排班
export const GetPositionScheduleList = {
  data() {
    return {
      resPositionScheduleList: []
    };
  },

  created() {
    this.xhrGetPositionScheduleList();
  },

  methods: {
    xhrGetPositionScheduleList() {
      this.$http.getPositionScheduleList({}).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.resPositionScheduleList = res.data;
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/mixincopy.js